import { useLazyGetAssetsQuery } from '@/store/api/diagnosticApi';
import {
  getAssetsFiltersData,
  setCurrentFiltersData,
  getAssetsFiltersValues,
  setAllFiltersValues,
  setInitialFiltersValues,
  setCurrentFiltersValues,
} from '@/store/slices/assetsPreviewSlice';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useAppFilters } from '@/hooks/shared';

export function useFetchAssets() {
  const { siteId } = useParams();
  const dispatch = useDispatch();
  const [fetchAssets, { data: assetsRaw, isLoading }] = useLazyGetAssetsQuery();
  const { assetsType: assetsCategory } = useAppFilters();

  useEffect(() => {
    if (siteId) {
      fetchAssets({
        site_id: siteId,
      }).unwrap();
    }
  }, [siteId]);

  useEffect(() => {
    if (assetsRaw && assetsCategory) {
      const filtersValues = getAssetsFiltersValues(assetsRaw, assetsCategory);
      const filtersData = getAssetsFiltersData(
        assetsCategory,
        assetsRaw,
        filtersValues.currentFiltersValues,
        filtersValues.allFiltersValues
      );
      dispatch(setCurrentFiltersData(filtersData));
      dispatch(setCurrentFiltersValues(filtersValues.currentFiltersValues));
      dispatch(setAllFiltersValues(filtersValues.allFiltersValues));
      dispatch(setInitialFiltersValues(filtersValues.initialFiltersValues));
    }
  }, [assetsRaw, assetsCategory]);

  // Memoize to keep stable reference unless actual data changes
  const assets = useMemo(() => assetsRaw, [assetsRaw]);

  return { assets, isLoading };
}
